import { DotNetFormulaResultModel } from 'src/domain/dynamic-form/models';

export abstract class FormulaTypeBaseHandler {
	protected next: FormulaTypeBaseHandler;

	public setNext(handler: FormulaTypeBaseHandler): void {
		this.next = handler;
	}

	public abstract handle(formula: DotNetFormulaResultModel, decimals: number | null): string | number;
}
